<footer id="footer">
  <div class="footer-top">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-11">
        <div class="row">
          <div class="col-12 col-md-3 footer-links">
            <img src="assets/img/logo-reachr-branco.png" alt="reachr" class="img-fluid mr-2" style="width: 150px;">
            <img src="assets/img/selo-lgpd.png" alt="lgpd" class="img-fluid ml-3" style="width: 100px;">
            <div class="social-links">
              <a class="elementor-icon elementor-social-icon elementor-social-icon-facebook elementor-repeater-item-6ede023" href="https://www.facebook.com/ReachrRecrutamento/" target="_blank">
                <i class="fab fa-facebook"></i>         
              </a>
              <a class="elementor-icon elementor-social-icon elementor-social-icon-instagram elementor-repeater-item-a22b554" href="https://instagram.com/reachrdigital" target="_blank">
                <i class="fab fa-instagram"></i>          
              </a>
              <a class="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-repeater-item-1a85017" href="https://www.linkedin.com/company/reachr-recrutamento/" target="_blank">
                <i class="fab fa-linkedin"></i>
              </a>
              <a class="elementor-icon elementor-social-icon elementor-social-icon-youtube elementor-repeater-item-1b7783b" href="https://www.youtube.com/@ReachrContratacaoDigital" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-3 footer-links">
            <h2>LINKS ÚTEIS</h2>
            <ul>
              <li><a href="/termos-de-uso">Termos de uso</a></li>
              <li><a href="/politica-de-privacidade">Política de privacidade</a></li>
              <li><a href="/faq">Dúvidas frequentes</a></li>
              <li><a href="/protecao-de-dados">Proteção de Dados Contatos do DPO</a></li>
              <li><a href="https://riovagas.com.br" target="_blank">Parceiro Rio Vagas</a></li>
            </ul>
          </div>
          <div class="col-12 col-md-3 footer-links">
            <h2>PARA EMPRESA</h2>
            <ul>
              <li><a href="https://blog.reachr.com.br">Blog</a></li>
              <li><a href="/planos">Planos</a></li>
              <li><a href="/cases">Clientes e Cases</a></li>
              <li><a href="/funcionalidades">Funcionalidades</a></li>
              <li><a href="https://vagasti.reachr.com.br">Contratar profissionais de TI</a></li>
            </ul>
          </div>
          <div class="col-12 col-md-3 footer-links">
            <h2>PARA CANDIDATO</h2>
            <ul>
              <li><a href="https://blog.reachr.com.br/category/carreiras">Blog</a></li>
              <li><a href="/para-candidatos/avaliacao-comportamental">Avaliação Comportamental</a></li>
              <li><a href="/vagas">Todas as vagas</a></li>
              <li><a href="https://vagasti.reachr.com.br">Vagas para Profissionais de Tecnologia</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>